const LoadState = {
  NotExist: 1,
  MissingDiscipline: 2,
  MissingChapter: 3,
  MissingLesson: 4,
  Loaded: 5,
};

export default Object.freeze(LoadState);
